import { BehaviorSubject } from 'rxjs';
import { config } from '../Constants';

const currentSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const authentication = {
    login,
    logout,
    currentUser: currentSubject.asObservable(),
    get currentUserValue() { return currentSubject.value }
};

function login(username, password) {
    //console.log(JSON.stringify({ username, password }));

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password, user_type: ["acc", "su", "hc"], system: "backend nirvana" }),

    };

    return fetch(config.url.API_URL + '/login', requestOptions)
        .then(res => res.json())
        .then(data => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if (data.status === "Success") {
                localStorage.setItem('currentUser', JSON.stringify(data));
                window.location.assign('/')
                //currentSubject.next(data);
            }
            return data;
        });
}

function logout() {
    // remove user from local storage to log user out
    const { jwt, user_id } = currentSubject.value;

    const requestOptions = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': jwt,
        },
        body: JSON.stringify({
            login: 0,
            token_access: '',
        }),
    };

    fetch(config.url.API_URL + '/useradmin/' + user_id, requestOptions)
        .then(res => res.json())
        .then(data => {
            localStorage.removeItem('currentUser');
            window.location.assign('/')
            //currentSubject.next(null);
        }).catch(function (error) {
            localStorage.removeItem('currentUser');
            window.location.assign('/')
            //currentSubject.next(null);
        });

}
